import { useUserRoleContext } from "../context/UserRoleContext";

/**
 * @param {number|string} clanicaID - Single clanicaID to check against user's clanicaID.
 * @param {Array} clanicaList - Optional array of objects with clanicaID to check membership.
 *
 * @returns {object}
 *   isLoading            - true while user role is being fetched
 *   isUserFromClanica    - true if user's clanicaID matches the provided clanicaID
 *   isUserClanicaInList  - true if user's clanicaID exists in the provided clanicaList
 */
const useClanicaCheck = (clanicaID = null, clanicaList = null) => {
  const { userRole, isLoadingUserRole } = useUserRoleContext();

  // Normalize user's clanicaID to a number if it exists, otherwise null
  const userClanicaID =
    userRole?.clanicaID != null ? Number(userRole.clanicaID) : null;

  // Check if user is from the specific clanicaID
  const isUserFromClanica =
    clanicaID != null &&
    userClanicaID != null &&
    userClanicaID === Number(clanicaID);

  // Check if user's clanicaID is in the provided clanicaList
  const isUserClanicaInList =
    Array.isArray(clanicaList) &&
    userClanicaID != null &&
    clanicaList.some((c) => Number(c.clanicaID) === userClanicaID);

  return {
    isLoading: isLoadingUserRole,
    isUserFromClanica,
    isUserClanicaInList,
  };
};

export default useClanicaCheck;
